module.exports = __webpack_public_path__ + "img/1.29fb2f90.jpg";